var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.rootElement,_vm._g({tag:"component",staticClass:"ds-card",class:[`elevation-${_vm.elevation}`, { clickable: _vm.clickable }]},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }